import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { useReports } from "@/lib/query-hooks";

export const Route = createFileRoute("/admin/reports")({
  component: ReportsPage,
});

function ReportsPage() {
  const [status, setStatus] = useState<"open" | "resolved" | "dismissed">("open");
  const { data, isLoading } = useReports(status);

  return (
    <div>
      <div className="label-card">Moderation</div>
      <div className="mt-1 flex items-end justify-between">
        <h1 className="font-display text-3xl font-semibold">Reports</h1>
        <div className="flex rounded-md border border-hairline overflow-hidden text-xs">
          {(["open", "resolved", "dismissed"] as const).map((s) => (
            <button
              key={s}
              onClick={() => setStatus(s)}
              className={`px-3 py-1.5 uppercase tracking-widest font-semibold ${
                status === s ? "bg-paprika text-white" : "hover:bg-surface-alt"
              }`}
            >
              {s}
            </button>
          ))}
        </div>
      </div>

      <ul className="mt-6 card-ledger divide-y divide-hairline overflow-hidden">
        {isLoading ? (
          <li className="p-6 text-ink-muted text-sm">Loading…</li>
        ) : !data?.length ? (
          <li className="p-10 text-center text-ink-soft">
            No {status} reports.
          </li>
        ) : (
          data.map((r) => (
            <li key={r.id} className="p-5">
              <div className="flex justify-between gap-4">
                <div>
                  <div className="font-semibold">
                    {r.file?.title ?? r.file?.name ?? r.fileId}
                  </div>
                  <div className="mt-1 text-sm text-ink-soft">{r.reason}</div>
                  {r.detail ? (
                    <p className="mt-2 text-sm text-ink-soft">{r.detail}</p>
                  ) : null}
                </div>
                <div className="text-xs text-ink-muted whitespace-nowrap">
                  {new Date(r.createdAt).toLocaleDateString()}
                </div>
              </div>
            </li>
          ))
        )}
      </ul>
    </div>
  );
}
